import { ProgramSummaryModal } from '../../archives/summary/ProgramSummaryModal';
import { getProgramSummaryForSubmitDownload } from '../../common/services/program-service';
import { submitProgram } from '../../common/handler/SubmitProgram';
import { modalUtils } from '@/app/core/utils';
import { Modal } from '@ssar-app/uikit';
import { AscendArchivesProgram } from '@ssar-app/domain';

export const showProgramSummary = async (
  model: AscendArchivesProgram,
  programId: string,
  version: string,
  showAccept: boolean,
  buildPath: (...paths: string[]) => string,
  draftId?: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  history?: any,
  setIsProcessing?: (processing: boolean) => void,
): Promise<void> => {
  const modal = Modal.info({
    icon: false,
    showFooterBtns: false,
    contentProps: { maxW: '80%' },
    content: <></>,
  });
  const closeModal = modal.destroy;
  modal.update({
    content: (
      <ProgramSummaryModal
        model={model}
        version={version}
        programId={programId}
        showAccept={showAccept}
        onAccept={async () => {
          if (showAccept) {
            submitProgram(
              model,
              model?.productInput?.productDetails?.programName || '',
              programId,
              draftId || '',
              history,
              closeModal,
              buildPath,
            );
          }
        }}
        onCancel={() => {
          setIsProcessing && setIsProcessing(false);
          closeModal();
        }}
        onDownload={(setDownloadLoading) => {
          getProgramSummaryForSubmitDownload(
            model.productInput?.productDetails?.programName || 'ProgramSummary',
            model,
            model?.dataDictionaryVersion || '',
          )
            .catch((err) => {
              modalUtils.showError(
                err,
                'Error while generating Program Summary',
              );
            })
            .finally(() => {
              setDownloadLoading(false);
            });
        }}
      />
    ),
  });
};
